import React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Logout from '../components/logout';
import RLSLogo from '../img/rls_logo_short.png';
import { Link } from 'react-router-dom';


class NavBar extends React.Component {

	render() {

		return (
			<div style={{ flexGrow: 1 }}>
				<AppBar position="static">
					<Toolbar>						
						<Typography variant="title" color="inherit" style={{ flex: 1, marginLeft: "3px" }}>
							<Link to='/home'>
								<img src={RLSLogo} alt="RLS By Rebny" style={{ width: "54px" }} />	
							</Link>							
						</Typography>
						<Logout {...this.props} />
					</Toolbar>
				</AppBar>
			</div>
		);
	}
}

export default NavBar;
